import { RootState } from '../../store';

export const getRoomsSelector = (state: RootState) => state?.ticketReducer?.rooms;
